import setUserThemeRequest from 'owa-service/lib/factory/setUserThemeRequest';
import setUserThemeOperation from 'owa-service/lib/operation/setUserThemeOperation';
export default function setUserTheme(themeId) {
    return setUserThemeOperation({
        request: setUserThemeRequest({
            ThemeId: themeId,
        }),
    });
}
//# sourceMappingURL=setUserTheme.js.map